import React from 'react';
import CurrencyInput from '../shared/CurrencyInput';
import TextField from '../shared/ppbn-textfield';
import { Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    addPart: {
        marginLeft: 20,
        padding: '5px'
    },
    partTextField: {
        marginLeft: 20,
        marginTop: 15,
        marginRight: theme.spacing.unit,
        width: 280,
    },
    partsContainer: {
        display: 'flex',
        flexWrap: 'wrap'
    },
});

class PartsListForm extends React.Component {

    addPart = () => {
        let newParts = this.props.parts.concat([{ number: '', price: 0 }])
        this.props.onChange({target : { id :"parts", value: newParts}});            
    };

    removePart = idx => () => {                    
        const newParts = this.props.parts.filter((s, sidx) => idx !== sidx);      
        this.props.onChange({target : { id :"parts", value: newParts}});
    };
    
    handlePartNumberChange = idx => evt => {        
        const newParts = this.props.parts.map((part, sidx) => {            
            if (idx !== sidx) return part;
            return { price: part.price, partNumber: evt.target.value };
        });                
            
        this.props.onChange({target : { id :"parts", value: newParts}});            
    };

    handlePartPriceChange = idx => evt => {
        const newParts = this.props.parts.map((part, sidx) => {
            if (idx !== sidx) return part;
            return { partNumber : part.partNumber, price: evt.target.value };
        });        
        this.props.onChange({target : { id :"parts", value: newParts}});            
    };

    render() {
        const { classes} = this.props;
        let parts = this.props.parts;        
        
        return (
            <div>
                <div className={classes.container}>
                    {parts && parts.map((part, idx) => (
                        <div key={`part${idx}`}className={classes.partsContainer}>
                            <TextField
                                autoFocus
                                inputProps={{ maxLength: 25 }}
                                className={classes.partTextField}
                                value={part.partNumber}
                                id={`partNumber${idx}`}
                                onChange={this.handlePartNumberChange(idx)}
                                label='Part Number' />
                            <CurrencyInput
                                type="number"
                                value={part.price}
                                id={`partPrice${idx}`}
                                className={classes.partTextField}
                                onChange={this.handlePartPriceChange(idx)}
                                label='Price' />
                            <Button onClick={this.removePart(idx)}>X</Button>
                        </div>
                    ))}
                </div>
                <Button id='add-part-button' onClick={this.addPart} className={classes.addPart}>+ Add Part</Button>
            </div>
        )
    }
}

export default withStyles(styles)(PartsListForm);
